import { CompositionGroupView } from '../article/variant/compositions/shared/group/CompositionGroupView';

export function PreviewTemplate({
  compositionGroupId,
}: {
  compositionGroupId: number;
}) {
  return (
    <CompositionGroupView
      componentSettings={{
        compositionArchiveRestore: 'hidden',
        addMaterials: 'hidden',
        materialsMode: 'read-only',
        removeMaterials: 'hidden',
        editImage: 'hidden',
        dimensionMode: 'read-only-group',
        expander: 'hidden',
      }}
      compositionGroupId={compositionGroupId}
      variantId={0}
    />
  );
}
